import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

interface MockTeamTrendChartProps {
    variant?: 'full' | 'compact';
    className?: string;
}

const LABELS = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8'];

const MOCK_DATA = {
    labels: LABELS,
    datasets: [
        {
            label: 'Team Max',
            data: [88, 85, 91, 87, 90, 86, 93, 89],
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            pointRadius: 0,
            borderWidth: 0,
            fill: false,
        },
        {
            label: 'Team Avg',
            data: [72, 69, 75, 73, 77, 74, 80, 76],
            borderColor: '#3B82F6',
            backgroundColor: 'rgba(59, 130, 246, 0.08)',
            pointRadius: 2,
            pointBackgroundColor: '#3B82F6',
            borderWidth: 2,
            tension: 0.3,
            fill: false,
        },
        {
            label: 'Team Min',
            data: [55, 48, 58, 52, 60, 56, 65, 61],
            borderColor: 'transparent',
            backgroundColor: 'rgba(59, 130, 246, 0.10)',
            pointRadius: 0,
            borderWidth: 0,
            tension: 0.3,
            fill: {
                target: 0,
                above: 'rgba(59, 130, 246, 0.10)',
                below: 'rgba(59, 130, 246, 0.10)',
            },
        },
    ],
};

const getOptions = (compact: boolean) => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: { color: 'rgba(255,255,255,0.04)' },
            ticks: {
                color: 'rgba(255,255,255,0.3)',
                font: { size: compact ? 8 : 10, family: 'Inter, sans-serif' },
            },
            border: { color: 'rgba(255,255,255,0.08)' },
        },
        y: {
            grid: { color: 'rgba(255,255,255,0.04)' },
            ticks: {
                color: 'rgba(255,255,255,0.3)',
                font: { size: compact ? 8 : 10, family: 'Inter, sans-serif' },
                maxTicksLimit: 5,
            },
            border: { color: 'rgba(255,255,255,0.08)' },
            suggestedMin: 30,
            suggestedMax: 100,
        },
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    events: [] as const,
});

const MockTeamTrendChart: React.FC<MockTeamTrendChartProps> = ({ variant = 'full', className = '' }) => {
    const compact = variant === 'compact';
    const height = compact ? 160 : 200;

    return (
        <div className={`relative ${className}`} style={{ height }}>
            <Line data={MOCK_DATA} options={getOptions(compact)} />
        </div>
    );
};

export default MockTeamTrendChart;
